// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"LJ-z","loadingMedia":"MJ-z","reviewsImagesAndVideos":"NJ-z","limitHeight":"OJ-z"};